(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-contact"]) return;
  try {
    
  class ContactForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.setAttribute('novalidate', '');
      this.fields = Array.from(this.querySelectorAll('[data-validate]'));

      for (const input of this.fields) {
        input.addEventListener('blur', () => this.validateField(input));
        input.addEventListener('input', () => {
          const field = input.closest('.contact__field');
          if (field && field.classList.contains('is-error')) this.validateField(input);
        });
      }

      // Email: strip whitespace, mirroring the old frontend.
      const email = this.querySelector('[data-validate="email"]');
      if (email) {
        email.addEventListener('input', () => {
          const stripped = email.value.replace(/\s/g, '');
          if (stripped !== email.value) email.value = stripped;
        });
        email.addEventListener('keydown', (e) => { if (e.key === ' ') e.preventDefault(); });
      }

      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    validateField(input) {
      const field = input.closest('.contact__field');
      const label = field.querySelector('.contact__label');
      const value = input.value.trim();
      const type = input.dataset.validate;
      let error = '';

      if (!value) {
        error = 'هذا الحقل مطلوب';
      } else if (type === 'name') {
        if (value.length < 2) error = 'أدخل اسم صالح';
        else if (value.length > 30) error = 'الاسم طويل جداً';
      } else if (type === 'email') {
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) error = 'أدخل بريد إلكتروني صالح';
      }

      if (error) {
        field.classList.add('is-error');
        label.textContent = error;
      } else {
        field.classList.remove('is-error');
        label.textContent = label.dataset.label;
      }
      return !error;
    }

    onSubmit(e) {
      let valid = true;
      for (const input of this.fields) { if (!this.validateField(input)) valid = false; }

      if (!valid) {
        e.preventDefault();
        const firstError = this.querySelector('.contact__field.is-error [data-validate]');
        if (firstError) firstError.focus();
        return;
      }

      const btn = this.form.querySelector('[data-submit]');
      if (btn && btn.dataset.loading) {
        btn.disabled = true;
        btn.textContent = btn.dataset.loading;
      }
    }
  }

  if (!customElements.get('contact-form')) customElements.define('contact-form', ContactForm);

  } catch(e) { console.error(e); }
})();
})();
